import { render, staticRenderFns } from "./CreateDemoAccount.vue?vue&type=template&id=13a17688"
import script from "./CreateDemoAccount.vue?vue&type=script&lang=js"
export * from "./CreateDemoAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports